import { render, staticRenderFns } from "./standardFactor.vue?vue&type=template&id=2d545756&scoped=true&"
import script from "./standardFactor.vue?vue&type=script&lang=js&"
export * from "./standardFactor.vue?vue&type=script&lang=js&"
import style0 from "./standardFactor.vue?vue&type=style&index=0&id=2d545756&prod&lang=css&"
import style1 from "./standardFactor.vue?vue&type=style&index=1&id=2d545756&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d545756",
  null
  
)

export default component.exports